import { useEffect, useRef, memo } from 'react';
import { useTelegram } from '../../app/providers/TelegramProvider';
import { useLocation, useNavigate } from 'react-router-dom';

interface BackButtonProps {
  visible?: boolean;
  onClick?: () => void;
}

export const BackButton = memo(
  ({ visible = true, onClick }: BackButtonProps) => {
    const { webApp } = useTelegram();
    const navigate = useNavigate();
    const location = useLocation();

    const onClickRef = useRef<BackButtonProps['onClick']>(undefined);
    const isShownRef = useRef(false);

    // Держим актуальный onClick
    useEffect(() => {
      onClickRef.current = onClick;
    }, [onClick]);

    // Регистрируем обработчик один раз
    useEffect(() => {
      if (!webApp?.BackButton) return;

      const handler = () => {
        // вызываем пользовательский onClick (если есть)
        onClickRef.current?.();

        // Если мы на странице баннера, возвращаемся в каталог
        if (location.pathname.startsWith('/banner/')) {
          navigate('/catalog');
        } else {
          // во всех остальных случаях — на главную
          navigate('/');
        }
      };

      webApp.BackButton.onClick(handler);

      return () => {
        webApp.BackButton.offClick();
      };
    }, [webApp, navigate, location.pathname]);

    // Управление видимостью
    useEffect(() => {
      if (!webApp?.BackButton) return;

      if (visible && !isShownRef.current) {
        webApp.BackButton.show();
        isShownRef.current = true;
      } else if (!visible && isShownRef.current) {
        webApp.BackButton.hide();
        isShownRef.current = false;
      }
    }, [visible, webApp]);

    // Прячем кнопку при размонтировании
    useEffect(() => {
      return () => {
        if (webApp?.BackButton && isShownRef.current) {
          webApp.BackButton.hide();
          isShownRef.current = false;
        }
      };
    }, [webApp]);

    return null;
  },
);
